module.exports = __webpack_public_path__ + "img/handshake-simple-slash.74432477.svg";